import axios from "../axiosInstance"

export const respondToOffer = async ({ dealId, offerNumber, isAccepted, declineMessage }: { dealId: number, offerNumber: number, isAccepted: boolean, declineMessage?: string }) => {
  try {
    const res = await axios.post("/offers/respond", { dealId, offerNumber, isAccepted, declineMessage })
    const { data } = res
    return data.success
  } catch (error) {
    console.error("Error responding to offer:", error)
    throw error
  }
}

export const markOfferViewed = async ({ dealId, offerNumber }: { dealId: number, offerNumber: number }) => {
  try {
    await axios.post("/offers/viewed", { dealId, offerNumber })
  } catch {
    // Fire-and-forget — don't disrupt the client experience
  }
}